import React, { Component } from 'react';
import CartSummary from './Checkout/CartSummary';
import { Redirect } from 'react-router';

import BillingForm from './Checkout/BillingForm';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/billing-dux';
import Layout from '../../ui/Layout';
import MetaTags from 'react-meta-tags';
import Loading from '../../ui/Loading';
import MetaLoader from '../../ui/MetaLoader';

const getInitialAddressValues = ({ billing, loggedIn, AddressBook }) => {
  if (!loggedIn || !!billing) {
    const {
      name_first,
      name_last,
      email,
      company,
      address1,
      address2,
      city,
      zip,
      phone,
      stateId
    } = billing || {};
    return {
      name_first,
      name_last,
      email,
      company,
      address1,
      address2,
      city,
      zip,
      phone,
      stateId
    };
  }

  const {
    FirstName: name_first,
    LastName: name_last,
    Email: email,
    Company: company,
    Address1: address1,
    Address2: address2,
    City: city,
    Zip: zip,
    Phone: phone,
    StateID: stateId
  } = (AddressBook || []).find(({ IsDefaultMailing }) => IsDefaultMailing) || {
  };

  return {
    name_first,
    name_last,
    email,
    company,
    address1,
    address2,
    city,
    zip,
    phone,
    stateId
  };
};

const getInitialCardId = ({ loggedIn, CreditCards }) => {
  if (!loggedIn) return null;

  const defaultCard = (CreditCards || []).find(({ IsDefault }) => IsDefault);

  const { CardId } = defaultCard || {};

  return CardId || null;
};

const getInitialValues = (
  { billing, payment, loggedIn, AddressBook, CreditCards, userEmail }
) => {
  const {
    name_first,
    name_last,
    email,
    company,
    address1,
    address2,
    city,
    zip,
    phone,
    stateId
  } = getInitialAddressValues({ loggedIn, billing, AddressBook });

  const cardId = getInitialCardId({ loggedIn, CreditCards });

  const {
    cardId: storedCardId,
    cardNumber,
    expirationMonth,
    expirationYear,
    cvv
  } = payment || {};

  return {
    name_first,
    name_last,
    email: email || userEmail,
    company,
    address1,
    address2,
    city,
    zip,
    phone,
    stateId,
    cardId: storedCardId || cardId || 'new',
    cardNumber: cardNumber || null,
    expirationMonth: expirationMonth || null,
    expirationYear: expirationYear || null,
    cvv: cvv || null
  };
};

class CheckoutBillingPage extends Component {
  constructor(props) {
    super(props);
    props.clearGetCart();
    props.clearGetCartBilling();
    props.clearGetCartShipping();
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getCart();
    this.props.getCartBilling();
    this.props.getCartShipping();
    this.props.getLookups();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-cart-shipping',
      'page-template-page-templatesshop-template-cart-shipping-php',
      'page',
      'page-id-237',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-cart-shipping',
      'page-template-page-templatesshop-template-cart-shipping-php',
      'page',
      'page-id-237',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const scrollToTop = () => window.scrollTo(0, 0);
    const {
      user,
      cart,
      billing,
      shipping,
      inProgress,
      postCartBilling,
      lookups,
      setBilling,
      payment,
      history,
      redirect,
      postPromoCode,
      delPromoCode,
      promoCodeResult,
      delPromoCodeResult
    } = this.props;

    if (redirect) return <Redirect to="/shop/checkout/shipping" />;

    const {
      shipper,
      promoCode
    } = cart || {};

    const { IsWillCall } = shipper || {};

    const loggedIn = user && user.userId;

    const { AddressBook, email, CreditCards } = user || {};

    const handlePostCartBilling = values => {
      const {
        cardNumber,
        expirationMonth,
        expirationYear,
        cvv,
        cardId,
        saveCard,
        ...payload
      } = values || {};
      postCartBilling({ payload }, 'checkout-billing-form', null, () =>
        history.push('/shop/checkout/review'));
      setBilling({
        cardNumber,
        expirationMonth,
        expirationYear,
        cvv,
        cardId,
        saveCard: cardId !== 'new' || !loggedIn ? false : !!saveCard
      });
    };

    const initialValues = getInitialValues({
      billing,
      payment,
      loggedIn,
      AddressBook,
      CreditCards,
      userEmail: email
    });

    const handlePostPromoCode = promoCode => postPromoCode({ promoCode });
    return (
      <Layout route="checkout">
        <MetaLoader title="Billing Details | Checkout | Twomey Cellars" />
        <MetaTags>
          <title>Billing Details | Checkout | Twomey Cellars</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta
            property="og:title"
            content="Billing Details | Checkout | Twomey Cellars"
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/shop/checkout/billing"
          />
        </MetaTags>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main shop-page nohero cart-page">
              <div className="container">

                <div className="row">
                  <div className="col-lg-8">

                    <section className="checkout-steps">
                      <div className="row no-gutters">
                        <div className="col">
                          <div className="active">
                            <strong>1</strong>
                            <h5>Shipping & Instructions</h5>
                          </div>
                        </div>
                        <div className="col">
                          <div className="active">
                            <strong>2</strong>
                            <h5>Billing & Payment</h5>
                          </div>
                        </div>
                        <div className="col">
                          <div>
                            <strong>3</strong>
                            <h5>Review & Submit</h5>
                          </div>
                        </div>
                      </div>
                    </section>

                    <h1 className="h3-style column-header">
                      Billing & Payment
                    </h1>

                    <div className="account-sections">

                      {inProgress && <Loading fullPage scrollToTop />}
                      {!inProgress &&
                        <BillingForm
                          onSubmit={handlePostCartBilling}
                          initialValues={initialValues}
                          lookups={lookups || {}}
                          loggedIn={loggedIn}
                          AddressBook={AddressBook}
                          shipping={shipping}
                          CreditCards={CreditCards}
                          IsWillCall={IsWillCall}
                          onPostPromoCode={handlePostPromoCode}
                          onDelPromoCode={delPromoCode}
                          cartPromoCode={promoCode}
                          promoCodeResult={promoCodeResult}
                          delPromoCodeResult={delPromoCodeResult}
                        />}

                    </div>
                  </div>

                  <div className="col-lg-4">
                    {!inProgress && <CartSummary {...cart} />}

                    <div className="cart-contact">
                      <h4>HAVE QUESTIONS?</h4>
                      <p>We’re here to help Mon-Fri 8am to 5pm PT</p>
                      <p>
                        Call (888) 202 2006 or
                        {' '}
                        <a href="mailto:customercare@twomey.com">email us</a>
                      </p>
                    </div>

                  </div>

                </div>
              </div>
            </main>
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    error: getCartError,
    inProgress,
    result: cart
  } = state.getCart.toJS();

  const {
    // error,
    inProgress: billingInProgress,
    result: billing
  } = state.getCartBilling.toJS();

  const {
    error: getCartShippingError,
    result: shipping
  } = state.getCartShipping.toJS();

  const {
    // error,
    inProgress: lookupsInProgress,
    result: lookups
  } = state.getLookups.toJS();

  const {
    result: user
  } = state.postLogin.toJS();

  const {
    inProgress: userInProgress
  } = state.validateLogin.toJS();

  const payment = state.billing || {};

  const redirect = getCartError || getCartShippingError;

  const promoCodeResult = state.postPromoCode.toJS();
  const delPromoCodeResult = state.delPromoCode.toJS();

  return {
    redirect,
    user,
    lookups,
    cart,
    billing,
    shipping,
    payment,
    promoCodeResult,
    delPromoCodeResult,
    inProgress: inProgress ||
      billingInProgress ||
      lookupsInProgress ||
      userInProgress
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      getCart: fetchDux.getCart.createAction,
      getCartBilling: fetchDux.getCartBilling.createAction,
      getCartShipping: fetchDux.getCartShipping.createAction,
      clearGetCart: fetchDux.getCart.clearAction,
      clearGetCartBilling: fetchDux.getCartBilling.clearAction,
      clearGetCartShipping: fetchDux.getCartShipping.clearAction,
      getLookups: fetchDux.getLookups.createAction,
      postCartBilling: fetchDux.postCartBilling.createAction,
      postPromoCode: fetchDux.postPromoCode.createAction,
      delPromoCode: fetchDux.delPromoCode.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(CheckoutBillingPage);
